import styled from "styled-components";

import Modal from "ds/Modal";

export const CancelModal = styled(Modal)`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  span {
    font-weight: 600;
    font-size: 13px;
  }
  p {
    margin: 0;
    font-size: 15px;
  }
`;

export const CancelModalHeader = styled.h2`
  margin: 1rem 0 0 0;
  font-weight: 700;
  font-size: 18px;
`;

export const Description = styled.span`
  font-weight: 600;
  font-size: 16px !important;
`;

export const CancelModalButtonGroup = styled.div<{ spaceBetween?: boolean }>`
  margin-top: 1rem;
  width: 100%;
  display: flex;
  justify-content: ${props =>
    props.spaceBetween ? "space-between" : "flex-end"};
  align-items: "center";
`;
